// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2021project/q1/2021economics/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};
const getVoteList = (type: any, page: number) => {
  return http.get(`${urlPrefix}vote-list`, {
    params: {
      awards: type,
      page,
    },
  });
};
const getDetail = (id: string) => {
  return http.get(`${urlPrefix}detail`, {
    params: {
      id,
    },
  });
};

const getRules = (type: any) => {
  const data: any = {
    1: `<p>今年是&ldquo;十四五&rdquo;规划的开局之年，是实现第一个百年奋斗目标之后向第二个百年奋斗目标进军的第一个五年，是中国共产党成立一百周年。</p>
<p>学习贯彻党的十九届五中全会精神和中央经济工作会议精神，贯彻落实习近平总书记对重庆提出的重要指示要求，发挥党报集团主流媒体舆论引导作用，继续携手重庆两江新区管委会共同主办以&ldquo;共赴新征程&middot;共书新篇章&rdquo;为主题的&ldquo;2020十大重庆经济年度人物&rdquo;评选活动，助力重庆经济高质量发展，献礼中国共产党百年华诞。</p>
<p>本次评选旨在挖掘贯彻新发展理念，坚持创新驱动发展，为推动成渝地区双城经济圈建设、脱贫攻坚、助力高质量发展、打造高品质生活做出重大贡献和显著成绩的领军人物。表彰其在产业转型升级、改革开放创新方面取得的成就和亮点，宣传其发展成果惠及人民群众，展示重庆内陆开放高地形象和优良营商环境。</p>
<p>&nbsp;&ldquo;十大重庆经济年度人物评选&rdquo;是重庆日报报业集团历经13年精心打造的现象级经济评选活动，是重庆经济类顶级活动名片，是向全球展示重庆高质量发展成果的形象窗口，在海内外具有强大的影响力和广泛的公信力。</p>`,
    2: `<p>（一）指导单位</p>
<p>重庆市委组织部、重庆市委宣传部、重庆市委统战部</p>
<p>（二）主办单位</p>
<p>重庆日报报业集团、重庆两江新区管委会</p>
<p>（三）组委会成员单位</p>
<p>重庆市科技局、重庆市经济信息委、重庆市人力社保局、重庆市规划自然资源局、重庆市住房城乡建委、重庆市城管局、重庆市交通局、重庆市农业农村委、重庆市商务委、重庆市文化旅游委、重庆市国资委、重庆市金融监管局、重庆市大数据发展局、重庆市工商联</p>
<p>（四）承办单位</p>
<p>重报都市传媒（上游新闻）、两江新区党工委宣传部</p>
<p>（五）媒体单位</p>
<p>重庆日报、上游新闻客户端、重庆晨报、重庆晚报、重庆商报、两江新区融媒体中心</p>`,
    3: `<p>（一）献礼建党一百周年，助力重庆高质量发展</p>
<p>评选积极践行&ldquo;十四五&rdquo;时期重庆经济社会发展建设指导思想，深入贯彻习近平总书记对重庆提出的重要指示要求。为中国共产党百年华诞献礼，推动重庆建成高质量发展高品质生活新范例，建设具有全国影响力的重要经济中心、科技创新中心、改革开放新高地、高品质生活宜居地。通过评选获奖名单，做到对当年的重庆经济社会发展&ldquo;一榜知天下&rdquo;。</p>
<p>（二）重庆顶级经济类评选，涵盖政商学三界</p>
<p>该评选活动于2008年正式创办，已成功举办十二届。评选出200余位积极推动重庆经济发展和社会进步的企业家、政府领导干部、科研专家或者经济学家。通过12年的评选，已成为重庆顶级经济类评选活动名片，在政商学各界认知度极高，2020十大重庆经济年度人物评选即将启动。</p>
<p>（三）各部委办局全程参与，确保公信力权威性</p>
<p>2021年，十大重庆经济年度人物评选活动组织架构全新升级，市委组织部、市委宣传部、市委统战部作为评选活动指导单位，组建由17家部委办局组成的评选组委会，以及30家市级综合部门、行业监管单位、高校专家组成的专家评审会，极大提升了评选活动的公信力和权威性。</p>
<p>（四）评选实现良好成果运用</p>
<p>评选组委会将积极推荐符合条件的获奖人参与&ldquo;重庆英才计划&rdquo;申报评审，入选后按规定兑现待遇，落实服务保障。2020年，重庆市特殊人才职称申报评定工作明确&ldquo;十大重庆经济年度人物&rdquo;&ldquo;十大重庆经济年度创新人物&rdquo;的获奖者，可直接申报经济类的副高级职称。</p>
<p>（五）重报集团发起主办，全媒体传播广泛</p>
<p>&ldquo;十大重庆经济年度人物评选&rdquo;作为重报集团重要的年度经济类品牌活动，宣传推广覆盖旗下重庆日报、上游新闻客户端、华龙网、《重庆晨报》、《重庆商报》、《重庆晚报》，都市报新媒体矩阵，以及央媒驻渝机构、行业头部媒体等全媒体平台，将对评选全程和参评人做全方位报道、展示。</p>`,
    4: `<p>重庆榜单：</p>
<p>1．2020十大重庆经济年度人物</p>
<p>2．2020十大重庆经济年度创新人物</p>
<p>3．单项奖：</p>
<p>（1）“推动成渝地区双城经济圈建设”贡献奖</p>
<p style="padding-left: 10px">重点考量在成渝地区双城经济圈建设中，推进新型基础设施建设，推动优势产业项目深度合作、促进产业链上下游分工协作，推动成渝科技协同创新，共建共享两地公共服务，带动乡村振兴等方面的杰出表率。</p>
<p>（2）“促进国内国际双循环经济发展”创新奖</p>
<p style="padding-left: 10px">重点考量在国内国际双循环相互促进的新发展格局下，立足重庆充分发挥市场主体优势，吸引全球创新资源，推进建立自主创新的现代产业链和产业链集群建设，构建国内经济为主体的大循环格局，促进形成国际循环的杰出表率。</p>
<p>两江新区榜单：</p>
<p>2020十大两江新区经济年度人物</p>`,
    5: `<p><strong>1．企业家参评条件：</strong></p>
<p>（1）参评人遵守国家法律，坚持正确政治方向，践行社会主义核心价值观；</p>
<p>（2）参评人具有良好职业道德，爱岗敬业，诚实守信，具有良好声誉和个人形象；</p>
<p>（3）参评人所在企业须在重庆设立实体机构并开展业务，成立时间3年以上（新经济业态的优秀企业可放宽至1年）；</p>
<p>（4）参评人所在企业在重庆及全国细分行业中拥有领先的市场地位、占有份额、营收水平、创新能力；</p>
<p>（5）参评人（十大重庆经济年度人物）所在企业在重庆地区2020年主营收入不低于3亿元，纳税金额不低于1000万元，解决就业人数不低于200人；</p>
<p>（6）参评人（十大重庆经济年度创新人物）所在企业在重庆地区2020年主营收入不低于5000万元，在科技创新、市场创新、制度创新、管理创新等方面有突出表现；</p>
<p>（7）参评人（十大两江新区经济年度人物）所在企业在重庆地区2020年主营收入不低于1亿元，纳税金额不低于500万元，解决就业人数不低于100人；</p>
<p>（8）2020全年在同一企业担任董事长、总裁及总经理等主要领导职务；</p>
<p>（9）参评人所在企业近3年内无重大安全和质量责任事故发生，参评人及所在企业无违法失信行为，并积极承担社会责任，热心社会公益事业。</p>
<p><strong>2．其他人士参评条件：</strong></p>
<p>2020年为推动重庆经济发展做出重大贡献和显著成绩，具有号召力和影响力的地方党政领导干部（厅局级以上干部除外）、科研专家、经济学家等人士。</p>`,
    6: `<p>1． 推荐报名</p>
<p>（1）定向推荐</p>
<p>（2）自荐</p>
<p style="text-align: left; padding-left: 40px;">参评年限：每5年（2020&mdash;2024年）为一个参评周期，5年周期内只获评一次&ldquo;十大重庆经济年度人物&rdquo;奖。</p>
<p>2．入围审查</p>
<p>3．专家评审</p>
<p>4．审定发布</p>
<p>5．表彰颁奖</p>
<p>&nbsp;</p>`,
  };
  return data[type];
};
export { getBaseInfo, getVoteList, getRules, getDetail };
